import * as yup from 'yup'

export const validateUpdateUsers = yup.object().shape({
    first_name: yup
    .string()
    .min(4, 'El NOMBRE debe tener más de 3 caracteres')
    .nullable()
    .required("campo requerido"),
    last_name: yup
    .string()
    .min(4, 'El APELLIDO debe tener más de 3 caracteres')
    .nullable()
    .required("campo requerido"),
    dni: yup
    .string()
    .min(4, 'La cédula debe tener más de 3 caracteres numéricos')
    .nullable()
    .required("campo requerido"),
    phone: yup
    .string()
    .min(3, 'El TELÉFONO debe tener más de 4 caracteres numéricos')
    .nullable()
    .required("campo requerido"),
    email: yup
    .string()
    .email('Introduzca un correo electrónico válido.')
    .nullable()
    .required("campo requerido"),
    password: yup
    .string()
    .transform((v) => (v === '' || v === undefined ? undefined : v))
    .notRequired()
    .test(
        'password-len',
        'Debe introducir una contraseña de al menos 6 caracteres.',
        (v) => v === undefined || v.length >= 6,
    ),
    role: yup
    .string()
    .oneOf(['user', 'admin', 'seller', 'domiciliary', 'integration'], 'Debes elegir entre estas opciones'),
    store_id: yup.mixed().when('role', {
        is: 'domiciliary',
        then: (schema) =>
            schema
                .required('Seleccione la sede asignada.')
                .test(
                    'store-required',
                    'Seleccione la sede asignada.',
                    (v) => v !== undefined && v !== null && v !== '',
                ),
        otherwise: (schema) => schema.nullable(),
    }),
    status: yup
    .string()
    .oneOf(['active', 'inactive', 'pending security verification', 'pending user data', 'pending validation'], 'Debes elegir entre estas opciones'),
    allowed_modules: yup.array().of(yup.string()).nullable().notRequired(),
})

